import React, { useEffect, useState } from 'react';

import ProductOptionInfo from '../ProductOptionInfo';
import ProductFeeInfo from '../ProductlFeeInfo';

const ProductOption = (props) => {
  const {
    isOption,
    form,
    isEditable,
    isCompare,
    comparisonData,
    minimumPrice,
    brandFeeInfoList,
    resetOptionAvailable,
    feeInfo,
    setIsGift,
  } = props;

  // 상품 옵션 여부와 상관 없이 choiceOption, optionList, optionKeyName 는 변경된 값을 항상 가지고 있어야하기 때문에
  // ProductOptionInfo 컴포넌트에서 form data 로 관리하지않고 상태값으로 가지고 있으면서 변경이 생겼을 경우
  // ProductOptionInfo 컴포넌트에서 form data 로 넣어줌
  const [choiceOption, setChoiceOption] = useState(props.choiceOption);
  const [optionList, setOptionList] = useState(props.optionList);
  const [optionKeyName, setOptionKeyName] = useState(props.optionKeyName);

  // choiceOption, optionList, optionKeyName 값을 해당 컴포넌트 마운트 이후에 가져오기 때문에 useEffect() 를 통해 값을 넣어줌
  useEffect(() => {
    setChoiceOption(props.choiceOption);
    setOptionList(props.optionList);
    setOptionKeyName(props.optionKeyName);
  }, [props.choiceOption, props.optionList, props.optionKeyName]);

  return (
    <>
      {isOption ? (
        <ProductOptionInfo
          form={form}
          isEditable={isEditable}
          isCompare={isCompare}
          comparisonData={comparisonData.optionList}
          choiceOption={choiceOption}
          setChoiceOption={setChoiceOption}
          optionList={optionList}
          setOptionList={setOptionList}
          optionKeyName={optionKeyName}
          setOptionKeyName={setOptionKeyName}
          minimumPrice={minimumPrice}
          brandFeeInfoList={brandFeeInfoList}
          resetOptionAvailable={resetOptionAvailable}
          setIsGift={setIsGift}
        />
      ) : (
        <ProductFeeInfo
          form={form}
          isEditable={isEditable}
          isCompare={isCompare}
          comparisonData={comparisonData.feeInfo}
          feeInfo={feeInfo}
          brandFeeInfoList={brandFeeInfoList}
          setIsGift={setIsGift}
        />
      )}
    </>
  );
};

export default ProductOption;
